// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  display: flex;
  flex-direction: column;

  .couponList__title {
    margin-top: ${(props) =>
      props.spc
        ? `${props.theme.spacing.ELEM_SPACING.LRG}`
        : `${props.theme.spacing.ELEM_SPACING.XS_6}`};
    margin-bottom: ${(props) =>
      props.spc
        ? `${props.theme.spacing.ELEM_SPACING.XXXS}`
        : `${props.theme.spacing.ELEM_SPACING.XS_1}`};
  }
  .couponList__iconContainer {
    display: flex;
    flex-direction: row;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XS};
    margin-bottom: ${(props) => props.theme.spacing.ELEM_SPACING.SM};
  }
  .couponList__helpIcon {
    text-align: center;
    line-height: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    font-size: ${(props) => props.theme.typography.fontSizes.fs10};
    background: ${(props) => props.theme.colors.PRIMARY.GREEN};
    color: ${(props) => props.theme.colors.WHITE};
    margin-right: ${(props) => props.theme.spacing.ELEM_SPACING.XXS};
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    width: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    height: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
  }

  .coupon-cards-container {
    display: flex;
    overflow-x: auto;
    scrollbar-width: none;
  }
  .right-arrow {
    display: none;
    ${(props) => (props.spc ? `@media ${props.theme.mediaQuery.large}{display:block;}` : '')};
    content: '';
    border: 1px solid ${(props) => props.theme.colorPalette.gray[800]};
    border-width: 0 1.5px 1.5px 0;
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    transform: rotate(315deg);
    width: 0px;
    height: 0px;
    position: sticky;
    top: 30px;
    right: 10px;
    @media ${(props) => props.theme.breakpoints.medium} {
      display: none;
    }
  }

  .slick-track {
    display: inline-flex;
  }

  .slick-prev,
  .slick-next {
    height: 96px;
    width: 15px;
    top: 40%;
  }

  .slick-prev {
    @media ${(props) => props.theme.mediaQuery.medium} {
      box-shadow: -4px 8px 24px 24px ${(props) => props.theme.colorPalette.white};
    }
  }

  .slick-next {
    @media ${(props) => props.theme.mediaQuery.medium} {
      box-shadow: 4px 0 24px 24px ${(props) => props.theme.colorPalette.white};
    }
  }
`;

export default styles;
